import {
  IEntregaDeTrabalho,
  IEntregaDeTrabalhoComplete,
  IEntregaDeTrabalhoReview,
  IListFilters,
  IReviewTimeStatistics,
  IStatistics
} from '../../pages/Dashboard/EntregaTrabalho/models'
import apiService from '../Api'

interface IList {
  draw: number
  start: number
  length: number
  order: {
    column: number
    dir: string
  }[]
  filters: IListFilters
}

export class EntregaDeTrabalhoService {
  async list(params: IList): Promise<{ data: IEntregaDeTrabalho[]; recordsFiltered: number }> {
    const queryParams = new URLSearchParams()
    queryParams.append('draw', params.draw.toString())
    queryParams.append('start', params.start.toString())
    queryParams.append('length', params.length.toString())
    queryParams.append('order[0][column]', params.order[0].column.toString())
    queryParams.append('order[0][dir]', params.order[0].dir)
    queryParams.append('search[value]', params.filters.search)
    queryParams.append('teacher', params.filters.teacher)
    queryParams.append('type', params.filters.type)
    queryParams.append('course[format]', params.filters.course.format)
    queryParams.append('course[name]', params.filters.course.name)
    queryParams.append('created_at[from]', params.filters.created_at.from)
    queryParams.append('created_at[to]', params.filters.created_at.to)
    queryParams.append('status', params.filters.status)

    return apiService.get('/entrega-de-trabalho', { params: queryParams }).then((response) => response.data)
  }

  async loadStatistics(filters: IListFilters): Promise<IStatistics> {
    const queryParams = new URLSearchParams()
    queryParams.append('search[value]', filters.search)
    queryParams.append('teacher', filters.teacher)
    queryParams.append('type', filters.type)
    queryParams.append('course[format]', filters.course.format)
    queryParams.append('course[name]', filters.course.name)
    queryParams.append('created_at[from]', filters.created_at.from)
    queryParams.append('created_at[to]', filters.created_at.to)
    queryParams.append('status', filters.status)

    return apiService
      .get('/entrega-de-trabalho/get-statistics', { params: queryParams })
      .then((response) => response.data)
  }

  async loadReviewTimeStatistics(filters: IListFilters): Promise<IReviewTimeStatistics> {
    const queryParams = new URLSearchParams()
    queryParams.append('search[value]', filters.search)
    queryParams.append('teacher', filters.teacher)
    queryParams.append('type', filters.type)
    queryParams.append('course[format]', filters.course.format)
    queryParams.append('course[name]', filters.course.name)
    queryParams.append('created_at[from]', filters.created_at.from)
    queryParams.append('created_at[to]', filters.created_at.to)
    queryParams.append('status', filters.status)

    return apiService
      .get('/entrega-de-trabalho/get-review-time-statistics', { params: queryParams })
      .then((response) => response.data)
  }

  async get(id: number): Promise<IEntregaDeTrabalhoComplete> {
    return apiService.get(`/entrega-de-trabalho/${id}`).then((response) => response.data)
  }

  async getCourses(): Promise<string[]> {
    return apiService.get('/entrega-de-trabalho/courses').then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/entrega-de-trabalho/${id}`)
  }

  async getByPublicId(publicId: string): Promise<IEntregaDeTrabalhoComplete> {
    return apiService.get(`/entrega-de-trabalho/public/${publicId}`).then((response) => response.data)
  }

  async updateStatus(id: number, status: string): Promise<void> {
    return apiService.put(`/entrega-de-trabalho/${id}/set-status`, { status })
  }

  async review(id: number, review: IEntregaDeTrabalhoReview): Promise<void> {
    return apiService.post(`/entrega-de-trabalho/review/${id}`, review).then((response) => response.data)
  }
}
